// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"9d8ea9dd","453":"23a7b91f","834":"99617b6b"}[chunkId] + ".chunk.js";
};